// extracted by mini-css-extract-plugin
export default {"container":"Index_container__j0B9U","form_container":"Index_form_container__UHY8c","left":"Index_left__zTSlo","right":"Index_right__KJYxn"};